import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getQuestions(params) {
    return apiService.get(endpoints.questionsAndAnswers.questions, { params });
  },

  getQuestion(questionId) {
    return apiService.get(endpoints.questionsAndAnswers.question(questionId));
  },

  createQuestion(data) {
    return apiService.post(endpoints.questionsAndAnswers.questions, data);
  },

  updateQuestion(questionId, data) {
    return apiService.patch(
      endpoints.questionsAndAnswers.question(questionId),
      data
    );
  },

  deleteQuestion(questionId) {
    return apiService.delete(
      endpoints.questionsAndAnswers.question(questionId)
    );
  },

  getAnswers() {
    return apiService.get(endpoints.questionsAndAnswers.answers);
  },

  getAnswer(answerId) {
    return apiService.get(endpoints.questionsAndAnswers.answer(answerId));
  },

  createAnswer(data) {
    return apiService.post(endpoints.questionsAndAnswers.answers, data);
  },

  createAnswerByQuestionId(id, data) {
    return apiService.post(
      endpoints.questionsAndAnswers.createAnswerForQuestion(id),
      data
    );
  },

  updateAnswer(answerId, data) {
    return apiService.patch(
      endpoints.questionsAndAnswers.answer(answerId),
      data
    );
  },

  deleteAnswer(answerId) {
    return apiService.delete(endpoints.questionsAndAnswers.answer(answerId));
  }
};
